export default __webpack_public_path__ + "static/media/vidya_sample_students_roster.f06e131b.csv";